export default __webpack_public_path__ + "static/media/settings-icon.2a624b7b.svg";